<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div class="lock-to-top" style="background-color: #ffffff">
					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="loading == true || isProcessing == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="loading == true || SelectedAttendanceHistory == undefined"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onViewAttendance()"
						>
							View Attendance History
						</button>
						<button
							[disabled]="loading == true || SelectedAttendance == undefined || isProcessing == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onPrintAttendanceHistory()"
						>
							Print Attendance History
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstAttendance"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedAttendanceHistory"
						dataKey="AttendanceHistoryID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--c_date-->
								<th>
									<!-- <p-columnFilter type="text" field="c_date" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--AttendanceStatusDesc-->
								<th>
									<p-columnFilter field="AttendanceStatusDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterAttendanceStatusDesc
												[ngModel]="value"
												[options]="lstAttendanceStatusDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ExcuseDesc-->
								<th>
									<p-columnFilter field="ExcuseDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterExcuseDesc
												[ngModel]="value"
												[options]="lstExcuseDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--EntryTypeDesc-->
								<th>
									<p-columnFilter field="EntryTypeDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterEntryTypeDesc
												[ngModel]="value"
												[options]="lstEntryTypeDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--EntryDT-->
								<th>
									<!-- <p-columnFilter type="text" field="EntryDT" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--AdminName-->
								<th>
									<p-columnFilter type="text" field="AdminName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--RecordStatusDesc-->
								<th>
									<p-columnFilter field="RecordStatusDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterRecordStatusDesc
												[ngModel]="value"
												[options]="lstRecordStatusDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--c_Comment-->
								<th>
									<p-columnFilter type="text" field="c_Comment" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="c_date">Last Modified<p-sortIcon field="c_date"></p-sortIcon></th>
								<th pSortableColumn="AttendanceStatusDesc">Status<p-sortIcon field="AttendanceStatusDesc"></p-sortIcon></th>
								<th pSortableColumn="ExcuseDesc">Excuse<p-sortIcon field="ExcuseDesc"></p-sortIcon></th>
								<th pSortableColumn="EntryTypeDesc">Entry Type<p-sortIcon field="EntryTypeDesc"></p-sortIcon></th>
								<th pSortableColumn="EntryDT">Entry Date/Time<p-sortIcon field="EntryDT"></p-sortIcon></th>
								<th pSortableColumn="AdminName">Created By<p-sortIcon field="AdminName"></p-sortIcon></th>
								<th pSortableColumn="RecordStatusDesc">Record Status<p-sortIcon field="RecordStatusDesc"></p-sortIcon></th>
								<th pSortableColumn="c_Comment">Comments<p-sortIcon field="c_Comment"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-Attendance>
							<tr [pSelectableRow]="Attendance" (dblclick)="onRowDblClick(Attendance)">
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ Attendance[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>

				<div class="TopMargin">
					<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
				</div>
			</div>
		</div>
	</div>
</div>
